var _path, _path2, _path3, _path4, _path5, _path6, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 450",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 40 L380 40 C410 40 420 60 420 90 L420 320 C420 350 400 380 370 380 L130 380 C100 380 80 350 80 320 L80 90 C80 60 90 40 120 40",
    fill: "#F39237"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80 200 L420 200 L420 320 C420 350 400 380 370 380 L130 380 C100 380 80 350 80 320 Z",
    fill: "#3E6B34"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80 240 Q 250 320 420 240",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 8,
    opacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80 280 Q 250 360 420 280",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 8,
    opacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80 320 Q 250 400 420 320",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 8,
    opacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M250 80 L250 240 M230 110 Q 250 90 270 110 M225 140 Q 250 120 275 140 M220 170 Q 250 150 280 170",
    fill: "none",
    stroke: "#FFC857",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 440,
    fontFamily: "Arial Black, sans-serif",
    fontSize: 62,
    letterSpacing: -2
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#3E6B34"
  }, "Harmana"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#F39237"
  }, "GEL"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ca83f235b2726907ccebae1e44a6d091.svg";
export { ForwardRef as ReactComponent };